import React, {useState} from 'react';
import {TableLineLoader} from "../../front/loader/TableLineLoader";
import DateService from "../../../service/DateService";
import {NavLink} from "react-router-dom";
import {ApiService} from "../../../service/ApiService";
import {DeleteConfirme} from "../DeleteConfirme";
import {equipment} from "../../../models/equipment";
import {scrollTo} from "../../../service/ToolsService";

type EquipmentListProp = {
  equipments: equipment[],
  loading?: boolean,
  refresh: () => void,
}

export const EquipmentList = ({equipments, loading, refresh}: EquipmentListProp) => {
  const [del, setDel] = useState(undefined as undefined | equipment);

  const deleteEquipment = async (equipment: equipment) => {
    await ApiService.delete(`/equipment/${equipment.equipmentId}`);
    refresh();
  };

  return (
    <>
      <table className="table table-responsive table-hover border">
        <thead>
        <tr className="table-primary">
          <th>Nom</th>
          <th className="text-center w100px">Photo</th>
          <th className="text-center w100px">Prix</th>
          <th className="text-center w100px">Collection</th>
          <th className="text-center w110px">Zone du corps</th>
          <th className="text-center w150px d-lg-table-cell d-none">Modification</th>
          <th className="w190px"></th>
        </tr>
        </thead>
        <tbody>
        {loading && (
          <tr>
            <td colSpan={7} className="pt-4 pb-4 ps-5 pe-5">
              <TableLineLoader/>
            </td>
          </tr>
        )}

        {!loading && equipments.map((equipment: equipment, i: number) => (
          <tr key={i} className="align-middle">
            <td>{equipment.label}</td>
            <td className="text-center">{equipment.picture && (<i className="fa-regular fa-image"/>)}</td>
            <td className="text-center">{equipment.price}€</td>
            <td className="text-center">{equipment.collection.label}</td>
            <td className="text-center">{equipment.bodyArea?.label ?? '~'}</td>
            <td className="text-center d-lg-table-cell d-none">
              {DateService
                .toLocaleString(equipment.updatedAt ?? equipment.createdAt, {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false})
              }
            </td>
            <td className="text-end">
              <NavLink to={`/admin/equipment/equipment/edit/${equipment.equipmentId}`} onClick={scrollTo} className="btn btn-xs btn-primary me-1">
                <i className="fa-solid fa-pencil me-1"/> modifier
              </NavLink>
              <button className="btn btn-xs btn-danger" onClick={() => setDel(equipment)}><i className="fa-solid fa-xmark me-1"/>supprimer</button>
            </td>
          </tr>
        ))}
        </tbody>
      </table>
      {del && (
        <DeleteConfirme confirme={(c: boolean) => {
          if (c) {
            deleteEquipment(del);
          }

          setDel(undefined);
        }}/>
      )}
    </>
  );
}
